import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/movies", label: "电影" },
  { to: "/tvseries", label: "电视剧" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                可可影视
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
                KEKE FILM
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  isActive(link.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden items-center rounded-full border border-background-300/70 bg-background-100 px-4 py-2 lg:flex"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索影视作品"
              className="ml-2 w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="ml-1 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 md:hidden cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-4 flex items-center rounded-full border border-background-300/70 bg-background-100 px-4 py-2"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索影视作品"
              className="ml-2 w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="ml-1 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50 cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-md px-4 py-3 text-sm font-medium cursor-pointer ${
                  isActive(link.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}